<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>

    <Sheet.Body class="mt-[18px]">
      <h2
        class="text-center text-[26px] font-medium leading-[30px] text-gray-800 max-w-1/2 mx-auto"
      >
        Deactivate or delete account
      </h2>

      <div class="mt-[58px] flex flex-col gap-10 pl-5 px-3">
        <div class="flex gap-5">
          <EyeClosedIcon class="size-[26px] shrink-0 text-gray-800" />
          <div>
            <p class="text-[18px] font-medium leading-[24px] text-gray-800">
              Deactivation is temporary
            </p>
            <p class="mt-2 text-[14px] leading-[20px] text-gray-800">
              Your account is disabled and your plan cancelled. You can log back
              in anytime to reactivate.
            </p>
          </div>
        </div>

        <div class="flex gap-5">
          <AlertIcon class="size-[26px] shrink-0 text-gray-800" />
          <div>
            <p class="text-[18px] font-medium leading-[24px] text-gray-800">
              Deletion is permanent
            </p>
            <p class="mt-2 text-[14px] leading-[20px] text-gray-800">
              Your account is removed and cannot be restored. Your registrations
              remain on Dacr as evidentiary records.
            </p>
          </div>
        </div>
      </div>
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col gap-2.5 px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button variant="danger" size="lg" @click="handleDeactivate">
        Deactivate account
      </Button>
      <Button variant="stroke" size="lg" @click="handleDelete">
        Delete account
      </Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import { EyeClosedIcon, AlertIcon } from '@dacr/icons'

const { close } = useSheet()

const handleDeactivate = () =>
  openDialog(Dialog.AccountClosureInfo, {
    props: { mode: 'deactivate' },
    stack: 'cover',
  })

const handleDelete = () =>
  openDialog(Dialog.AccountClosureInfo, {
    props: { mode: 'delete' },
    stack: 'cover',
  })
</script>
